app.controller('nbhdFairnessController', function ($scope, $sce, $filter, $http, $routeParams, $location, storageService, constants, urls, keys, safeApply, cookieService, apiService) {

  mapboxgl.accessToken = apiService.getMapboxAccessToken()

  const minSizeForBounds = 400
  let map, bounds

  $scope.initializing = true
  $scope.analysis = null
  $scope.subj = null
  $scope.comp = null
  $scope.class = null
  $scope.config = {
    current_selection: 'perSqft',
    message: '',
    hide_info_modal: false
  }
  $scope.cog_loader_title = "Scanning Your Neighborhood..."

  let info_modal = new bootstrap.Modal(document.getElementById('info_modal'))
  let comp_info_modal = new bootstrap.Modal(document.getElementById('comp_info'))
  let subj_info_modal = new bootstrap.Modal(document.getElementById('subj_info'))

  initController()
  async function initController() {
    let value = storageService.getCookie('PTIO_showInfoModal')
    $scope.config.hide_info_modal = (value == 1) ? true : false
    console.log('apiService.analysisLoaded() :>> ', apiService.analysisLoaded());
    // if (apiService.analysisLoaded() == false) {
    let analysis = await apiService.getAnalysis({ appeal_id: $routeParams.appeal_id, cad_code: $routeParams.cad_code })
    $scope.analysis = analysis.data.data.analysis
    // } else {
    // $scope.analysis = await apiService.loadAnalysis()
    // }
    console.log('$scope.analysis :>> ', $scope.analysis);
    $scope.config.current_selection = $scope.analysis.fairness.defaultLayer
    $scope.initializing = false
    $scope.subject_map_url = await apiService.setSubjectMap({ lng: $scope.analysis.subj.geo_location.lng, lat: $scope.analysis.subj.geo_location.lat })
    initDynamicContent()
    setTimeout(() => {
      initMap($scope.analysis)
      safeApply($scope)
    }, 0)
  }

  $scope.update_info_modal_status = () => {
    console.log("in update_info_modal_status()");
    console.log('$scope.config.hide_info_modal :>> ', $scope.config.hide_info_modal);
    const value = $scope.config.hide_info_modal ? 1 : 0
    storageService.setCookie('PTIO_showInfoModal', value, 10)
  }

  // reset comps view when resizing if manually set to map
  window.onresize = () => { reDrawMap() }
  function reDrawMap() {
    if (window.innerWidth >= minSizeForBounds && map) {
      map.resize()
      map.fitBounds(bounds, { padding: 50 })
      safeApply($scope)
    }
  }

  function initMap(data) {

    if (map != undefined) return

    const cad_code = data.subj.cad_code
    const subjCadAccount = data.subj.cad_account
    data = data.fairness

    const subj = data.comps[subjCadAccount]

    const comps = data.comps;
    let mapBounds = data.mapBounds;
    const layers = data.layers;

    subj.value = subj.tax_value
    $scope.subj = subj

    $scope.config.message = data.layerText[data.defaultLayer]

    map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/glenng/clb5jetvv001015rs0i0qwd7c',
      center: [subj.longitude, subj.latitude],
      zoom: (window.innerWidth >= minSizeForBounds) ? 16 : 15.2
    })

    map.on('load', () => {
      bounds = new mapboxgl.LngLatBounds()
      mapBounds.map(prop => {
        bounds.extend([prop.longitude, prop.latitude])
      })
      // Skip on mobile devices
      if (window.innerWidth >= minSizeForBounds) {
        map.fitBounds(bounds, {
          padding: 50
        })
      }

      map.addSource('comps', {
        type: 'vector',
        url: 'mapbox://glenng.a1g4zj1h'
      })

      Object.keys(layers)
        .forEach(layerName => {
          if (layerName == 'subj' || layerName == 'props') return
          if (layerName == $scope.config.current_selection) {
            map.addLayer(layers[layerName])
          } else {
            map.addLayer(layers[layerName])
            map.setLayoutProperty(layerName, 'visibility', 'none')
          }
        })

      let propsLayer = layers.props
      let subjLayer = layers.subj

      let selectedLayer = document.getElementById('selectedLayer')
      selectedLayer.addEventListener('change', (e) => {
        let selectedLayer = e.target.value
        $scope.config.message = data.layerText[selectedLayer]
        Object.keys(layers)
          .forEach(layerName => {
            if (layerName == 'subj' || layerName == 'props') return
            selectedLayer == layerName ? map.setLayoutProperty(layerName, 'visibility', 'visible') : map.setLayoutProperty(layerName, 'visibility', 'none')
          })
        map.resize()
        safeApply($scope)
      })

      console.log('subjLayer :>> ', subjLayer);
      console.log('propsLayer :>> ', propsLayer);

      map.addLayer(propsLayer)
      map.addLayer(subjLayer)

      map.resize()
      if (!$scope.config.hide_info_modal) info_modal.show()

      map.on('click', 'subject', async (e) => {
        // console.log('subj clicked -> e :>> ', e)
      })

      console.log(cad_code);

      let currSelection
      map.on('click', 'props', async (e) => {


        let parcelId = e.features[0].properties[data.layerKey]

        console.log('parcelId == subjCadAccount :>> ', parcelId, subjCadAccount);

        let mapLayer = map.getLayer('comp-selected');
        if (parcelId == currSelection) {
          map.removeLayer('comp-selected');
          currSelection = undefined;
        } else if (parcelId == subjCadAccount) {
          subj_info_modal.show()
        } else if (parcelId != currSelection && parcelId != subjCadAccount) {
          currSelection = parcelId
          if (typeof mapLayer != 'undefined') {
            map.removeLayer('comp-selected')
          }
          map.addLayer({
            id: 'comp-selected',
            type: 'line',
            source: 'comps',
            'source-layer': `c_${cad_code}_parcels`,
            filter: ['==', `${data.layerKey}`, parcelId],
            paint: {
              "line-color": 'yellow',
              "line-width": 2
            }
          })
          $scope.comp = comps[parcelId]
          safeApply($scope)
          comp_info_modal.show()
        }
      })
    })
  }

  $scope.calcPercentageChange = (current, previous) => {
    return (((current - previous) / previous) * 100)
  }

  function initDynamicContent() {
    setTimeout(() => {
      tippy('.data__prices', {
        allowHTML: true,
        placement: 'top',
        animation: 'scale',
        delay: [200, 50],
      })

      $(".preloader").fadeOut(200, 'swing')
    }, 0)
  }

})
// End:  nbhdFairnessController
